import { TransactionHistoryActionTypes } from "./constannts";

const INITIAL_TRANSACTION_HISTORY = {
    transactionHistory: [],
    loading: false,
    error: null
}



const transactionHistoryReducer = (state = INITIAL_TRANSACTION_HISTORY, action) => {
    switch (action.type) {
        case TransactionHistoryActionTypes.TRANSACTION_HISTORY_LOADING:
            return {
                ...state,
                loading: true,
            };
        case TransactionHistoryActionTypes.TRANSACTION_HISTORY_SUCCESS:
            return {
                transactionHistory: action.payload,
                loading: false,
            };
        case TransactionHistoryActionTypes.TRANSACTION_HISTORY_ERROR:
            return {
                transactionHistory: action.payload,
                loading: false,
            };
        case TransactionHistoryActionTypes.TRANSACTION_HISTORY_RESET:
            return { ...INITIAL_TRANSACTION_HISTORY };
        default:
            return state;
    }
};
const deletedTransactionHistoryReducer = (state = INITIAL_TRANSACTION_HISTORY, action) => {
    switch (action.type) {
        case TransactionHistoryActionTypes.DELETED_TRANSACTION_HISTORY_LOADING:
            return {
                ...state,
                loading: true,
            };
        case TransactionHistoryActionTypes.DELETED_TRANSACTION_HISTORY_SUCCESS:
            return {
                transactionHistory: action.payload,
                loading: false,
            };
        case TransactionHistoryActionTypes.DELETED_TRANSACTION_HISTORY_ERROR:
            return {
                transactionHistory: action.payload,
                loading: false,
            };
        case TransactionHistoryActionTypes.TRANSACTION_HISTORY_RESET:
            return { ...INITIAL_TRANSACTION_HISTORY };
        default:
            return state;
    }
};

export { transactionHistoryReducer,deletedTransactionHistoryReducer }
